import * as C from "../Vars/charts";
import ResponsiveTable from './ResponsiveTable';
import Helper from "./Helper.js";



class ChartTableHandler {
  constructor() {
    this.buildTable();
  }

  buildTable(){
    let rows = C.csvChartData;
    let csvConfigColumnArr = C.csvChartCSVConfigArray;
    let inactiveCatsArray = [];

    let inactiveCats = C.URLParams["inactiveCats"];
    if(inactiveCats){
      inactiveCats = inactiveCats.split('-');
      inactiveCats.forEach(catsIndex => {
        inactiveCatsArray.push(parseFloat(catsIndex));
      })
    }

    // grab Index of Name column for table Building
    let nameIndex = null;
    let yAxisIndex = null;
    for (let i = 0; i < csvConfigColumnArr.length; i++) {
      if (csvConfigColumnArr[i] == "name") {
        nameIndex = i;
      }
      if (csvConfigColumnArr[i] == "yAxis") {
        yAxisIndex = i;
      }
    }

    // Build Table

    let tableHTML = `<div><table>`;
    rows.forEach((row, i) => {
      let seriesIndex = i-1;
      tableHTML += `<tr data-row-index="${i}" data-series-index="${seriesIndex}">`;
      if (i == 0) {
        row.forEach((col, index) => {
          let catIndex = index - csvConfigColumnArr.length;
          if(index == nameIndex){
            tableHTML += `<th data-series-index="${seriesIndex}" data-category-index="${catIndex}">${C.currentChartName}</th>`;
          } else if( index >= csvConfigColumnArr.length){
            tableHTML += `<th data-series-index="${seriesIndex}" data-category-index="${catIndex}">${col}</th>`;
          }
        });
      } else {
        row.forEach((col, index) => {
          let catIndex = index - csvConfigColumnArr.length;
          let val = parseFloat(col);
          if(!isNaN(val)) {
            col = this.formatNumber(parseFloat(col), C.thousandsSep, C.decimalPoint);
          }
          if (index == nameIndex) {
            // yAxis Label info
            let currentyAxis = (yAxisIndex) ? rows[i][yAxisIndex] : 0;
            let axisTitle = (currentyAxis == 0) ? C.currentChartyAxisTitle : '%';
            tableHTML += `<td data-series-index="${seriesIndex}" data-category-index="${catIndex}">${col} (${axisTitle})</td>`;
          }
          if (index >= csvConfigColumnArr.length) {
            tableHTML += `<td data-series-index="${seriesIndex}" data-category-index="${catIndex}">${col}</td>`;
          }
        });
      }
      tableHTML += `</tr>`;
    });
    tableHTML += `</table></div>`;
    let table = document.createElement('div');
    table.innerHTML = tableHTML;
    let tableContainer = document.querySelector('#table-container');
    tableContainer.innerHTML = '';
    tableContainer.append(table);

    new ResponsiveTable({
      tableSelector: '#table-container table',
      tableWrapperSelector: '#table-container',
      breakPointLg: 1200,
      breakPointMd: 768,
      colCountNoSplit: 3,
      colCountEarlyBreak: 7,
    });

    C.currentInactiveSeriesArray.forEach(seriesIndex => {
      Array.prototype.slice.call(document.querySelectorAll('#table-container [data-series-index="'+seriesIndex+'"]')).forEach(item => {
        item.remove();
      });
    });
    inactiveCatsArray.forEach(catIndex => {
      Array.prototype.slice.call(document.querySelectorAll('#table-container [data-category-index="'+catIndex+'"]')).forEach(item => {
        item.remove();
      });
    });
  }

  formatNumber(num, thousandsSep, decimal) {
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    return num_parts.join(decimal);
  }

}

export default ChartTableHandler;
